/**
 *
 */
export enum PAYMENT_TARGET_TYPE {
  Shuttle = 'ST',
  SpecialClass = 'SC',
  Default = 'ET',
}

/** CA0003 학원구분 — campusData의 campusDiv와 동일 (직영 DR / 가맹 BR) */
export const CAMPUS_DIV_DIRECT = 'DR';
export const CAMPUS_DIV_FRANCHISE = 'BR';

/* DatePicker 기간 간편 선택 화면 타입 */
export enum DateTableType {
  Simple = 1,
  SimpleYesterDay = 2,
  ALL = 0
}

/* DatePicker 기간 간편 선택 화면 타입 (선택값) */
export enum DateSelectType {
  YDAY = 1,
  TDAY = 2,
  DAYS3 = 3,
  DAYS7 = 4,
  DAYS15 = 5,
  MONTH1 = 6,
  MONTH3 = 7,
  MONTH6 = 8,
  YEAR1 = 9,
  NULL = 0,
}

/* 수입지출 메뉴타입 */
export enum FinancialMenuType {
  INCOME = 1,
  EXPENSE = 2,
  EXPENSE_APPROVAL = 3,
  INCOME_EXPENSE = 4,
  CASH_FLOW = 5,
  EXCEPTION = 6,
  CLOSING = 7
}

/* 수입 페이지 타입 */
export enum IncomePageType {
  CREATE = 1,
  UPDATE = 2,
  COPY = 3,
  VIEW = 4
}

/* 지출 페이지 타입 */
export enum ExpensePageType {
  CREATE = 1,
  UPDATE = 2,
  COPY = 3,
  VIEW = 4,
  AMOUNT_UPDATE = 5,
}

/* 결재 상태 타입 */
export enum ApprovalStatusType {
  WAIT = 'WA',
  PENDING = 'PE',
  COMPLETE = 'CO',
  REJECT = 'RJ',
  CANCLE = 'CA'
}

/* 결재 라인 타입 */
export enum ApprovalLineType {
  APPROVAL_LINE = 'AL',
  CC_LINE = 'CL'
}

/**
 * 매니저 권한
 * 각 부서 대표의 권한
 */
export const MANAGER = [1000, 1001, 1002, 1011, 1023];

/**
 * 운영팀 권한
 * 2024-12-24: 권순갑 차장님 요청 - 수강반 알림장 수정 권한 추가
 */
export const OPERATIONS_TEAM = [1000, 1001, 1002, 1003, 1004, 1011, 1012, 1023];

export const PERMISSIONS = {
  MANAGER,
  OPERATIONS_TEAM
}

/* 수입/지출 원장 권한 */
export const FI_DIRECTOR_AUTH = [1001, 1002];
/* 수입/지출 마감 권한 */
export const FI_CLOSING_AUTH = [1000, 1001, 1002, 1011, 1012];

/** 학기 타입 */
export const SEMESTER_TYPE = {
  REGULAR: "RG",
  SPECIAL_CLASS: "SC"
}

/** 언어 타입 */
export const LANGUAGE = {
  KOREAN: "ko",
  ENGLISH: "en"
}
  
export const DATE_FORMAT = {
  HYPHEN: {
    YYYY_MM_DD: 'YYYY-MM-DD'
  }
};

/* CANBot 평가 유형(Rubric) */
export enum CANBOT_EVALUATION_TYPE {
  OVERALL_COMMENT = 'Overall Comment',
  STRENGTH = 'Strength',
  AREA_FOR_IMPROVEMENT = 'Area for Improvement',
  INTERACTION = 'Interaction',
  COHERENCE = 'Coherence',
  LANGUAGE_USE = 'Language Use'
}

/**
 * 본사 학사팀 운영 권한
 */
export const PAYMENT_EDIT_HQ_MANAGER = [1000, 1023];
/**
 * 캠퍼스 운영 권한
 */
export const PAYMENT_EDIT_CAMPUS_MANAGER = [1002, 1003, 1011];

export const PAYMENT_EDIT_PERMISSIONS = {
  PAYMENT_EDIT_HQ_MANAGER,
  PAYMENT_EDIT_CAMPUS_MANAGER
}
/**
 * 재무관리팀 권한
 */
export const FINANCIAL_TEAM_CODE = 1017;
/**
 * SUM 지출 개인 수정 권한
 */
export const FINANCIAL_EDIT_PERMISSION = ['CB00025974'];

/** 동의 구분 — SIGNUP: 회원가입(학부모 계정 단위) / ADMISSION: 입학동의(학생×캠퍼스 단위) */
export enum ConsentDiv {
  Signup = 'SIGNUP',
  Admission = 'ADMISSION',
}

export interface IConsentItemDef {
  code: string;
  label: string;
  div: ConsentDiv;
  /** 필수/선택 동의 항목 */
  required: boolean;
}

/** 회원가입 동의 항목. MALL 은 개편 시점 기존 회원에게 면제(E) 처리되어 미동의로 잡히지 않는다. */
export const SIGNUP_CONSENT_ITEMS: IConsentItemDef[] = [
  { code: 'SERVICE', label: '서비스 이용약관', div: ConsentDiv.Signup, required: true },
  { code: 'MALL', label: '캔비몰 이용약관', div: ConsentDiv.Signup, required: true },
  { code: 'PRIVACY', label: '개인정보 수집이용', div: ConsentDiv.Signup, required: true },
  { code: 'THIRD', label: '개인정보 제3자 제공', div: ConsentDiv.Signup, required: true },
  { code: 'OVERSEAS', label: '개인정보 국외이전', div: ConsentDiv.Signup, required: true },
  { code: 'VOICE', label: '음성권', div: ConsentDiv.Signup, required: true },
  { code: 'MARKETING', label: '마케팅', div: ConsentDiv.Signup, required: false },
];

/** 입학동의 항목 (학생×캠퍼스 단위) */
export const ADMISSION_CONSENT_ITEMS: IConsentItemDef[] = [
  { code: 'ADM_PRIVACY', label: '개인정보 수집이용', div: ConsentDiv.Admission, required: true },
  { code: 'ADM_THIRD', label: '개인정보 제3자 제공', div: ConsentDiv.Admission, required: true },
  { code: 'ADM_RULE', label: '학원 생활 규칙', div: ConsentDiv.Admission, required: true },
  { code: 'ADM_EXPEL', label: '퇴원(제적) 규정', div: ConsentDiv.Admission, required: true },
  { code: 'ADM_SHUTTLE', label: '셔틀버스', div: ConsentDiv.Admission, required: true },
  { code: 'ADM_ONLINE', label: '온라인 보완학습', div: ConsentDiv.Admission, required: true },
  { code: 'ADM_PORTRAIT', label: '초상권', div: ConsentDiv.Admission, required: false },
];

/** 수강반 상태 (검색조건 기본값 PL, RE) */
export const CONSENT_CLASS_STATUS_LIST = [
  { code: 'PL', label: '예약' },
  { code: 'RE', label: '등록' },
  { code: 'GR', label: '수료' },
  { code: 'WI', label: '퇴원' },
];